/**
 * 动能值明细类型
 */
export enum PowerDetailTypeEnum {
  // 购买
  Purchase = "USER_PAY",
  // 赠送
  Provided = "PROVIDED",
  // 消耗
  Consumption = "CONSUME_AUTO",
}

/**
 * 机器人状态
 */
export enum AppStatusEnum {
  // 生效
  Effective = "ENABLE",
  // 到期
  Expired = "DISABLE",
}

/**
 * 机器人状态颜色
 */
export const AppStatusDotColor = {
  [AppStatusEnum.Effective]: "#5ACF57",
  [AppStatusEnum.Expired]: "#FF3838",
};

export * from "./request";
export * from "./orders";
export * from "./incomes-and-expenditures";
